//#region DevExtreme Imports

import 'devextreme/ui/form'

//#endregion

import { $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"

import { IMRBaseComponent } from "../../common/base"

import { IMRTaskVerificationHistoryController } from "./task-verification-history.controller"

//#region Asset Imports

import './task-verification-history.scss'
import * as TEMPLATE from './task-verification-history.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrTaskVerificationHistory'

export class IMRTaskVerificationHistoryComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: IMRTaskVerificationHistoryController,
            services: [$TIMEOUT_SERVICE_NAME, USER_SESSION_SERVICE_NAME],
            template: TEMPLATE
        })
    }
}
